import { User } from "@dulce/models/dist/users.models"
import { config } from "../../config"
import { authAxios } from "../../utils/authAxios"

const baseUrl = config.api.url

export const getSelf = async () => authAxios.request<User>({
  method: "GET",
  url: `${baseUrl}/users/self`,
}).then(res => res.data)